<template>
	<div class="app-recommend">
		<h3 class="recommend-title">{{ appRecommend.title }}</h3>
		<div class="recommend-subtitle">{{ appRecommend.subTitle }}</div>
		<ul class="recommend-list dp-f">
			<li
				class="rd-block"
				v-for="block in appRecommend.blocks"
				:key="block.name"
				:style="blockStyle"
			>
				<div class="rd-block-logo" v-if="block.logo">
					<img :src="block.logo" alt="" />
				</div>
				<p class="rd-block-text" :style="textStyle">{{ block.text }}</p>
				<div class="rd-block-name">{{ block.name }}</div>
				<div class="rd-block-company">{{ block.company }}</div>
			</li>
		</ul>
	</div>
</template>
<script>
export default {
	props: {
		appRecommend: {
			type: Object,
			required: true,
		},
	},
	computed: {
		textStyle() {
			return this.appRecommend.style && this.appRecommend.style.text
		},
		blockStyle() {
			return this.appRecommend.style && this.appRecommend.style.block
		},
	},
}
</script>
<style lang="scss" scoped>
.app-recommend {
	margin-top: 160px;
	.recommend-list {
		padding-top: 24px;
		justify-content: center;
		flex-wrap: wrap;
		margin: 0 auto;
		max-width: 1200px;
	}
	h3.recommend-title {
		font-size: 32px;
		text-align: center;
		color: #3f4657;
	}
	.recommend-subtitle {
		margin-top: 24px;
		font-size: 16px;
		text-align: center;
		color: #6d6d6d;
	}
	.rd-block {
		box-sizing: border-box;
		margin: 40px 20px 0;
		width: 360px;
		padding: 0 26px;
		border-radius: 8px;
		box-shadow: 0 2px 64px 0 rgba(159, 166, 176, 0.16);
		border: solid 1px #ebf3ff;
		background: #fff;
	}
	.rd-block-logo {
		margin-top: 36px;
		text-align: center;
		img {
			height: 32px;
		}
	}
	.rd-block-text {
		margin-top: 40px;
		font-size: 14px;
		line-height: 24px;
		height: 240px;
		color: #6d6d6d;
	}
	.rd-block-name {
		text-align: right;
		color: #3f4657;
		display: flex;
		justify-content: flex-end;
		align-items: center;
		&::before {
			content: '';
			margin-right: 16px;
			display: inline-block;
			width: 100px;
			height: 1px;
			background-color: #f4f4f4;
		}
	}
	.rd-block-company {
		margin-top: 8px;
		padding-bottom: 40px;
		font-size: 12px;
		text-align: right;
		color: #c2c9d5;
	}
}

@media (max-width: 414px) {
	.app-recommend {
		margin-top: 80px;
	}
}
</style>
